export const EMBED_ADMIN_BASE_URL = 'https://embed-admin.typeform.com'
export const MESSAGE_ORIGINS_WHITELIST = [EMBED_ADMIN_BASE_URL]
export const DEFAULT_EMBED_ADMIN_APP_NAME = 'default'
